import script from "./OrderPriceWithBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPriceWithBalance.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPriceWithBalance.vue?vue&type=style&index=0&id=0ccaac26&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccaac26"]])

export default __exports__